import { metricNames } from '@linearb/linjs-common';

export const TABLE_MODEL = {
  TEAM_NAME: 'team_name_cell',
  MEMBERS: 'members_cell',
  CYCLE_TIME: metricNames.CYCLE_TIME,
  PR_SIZE: metricNames.PR_SIZE,
  // MERGE FREQUENCY:
  PR_MERGED: metricNames.PR_MERGED,
  // DEPLOY FREQUENCY:
  RELEASES_COUNT: metricNames.RELEASES_COUNT,
  TIME_TO_PR: metricNames.TIME_TO_PR,
  TIME_TO_REVIEW: metricNames.TIME_TO_REVIEW,
  REVIEW_TIME: metricNames.REVIEW_TIME,
  TIME_TO_PROD: metricNames.TIME_TO_PROD,
  REVIEW_DEPTH: metricNames.REVIEW_DEPTH,
  NEW_WORK: metricNames.NEW_WORK,
  REFACTOR: metricNames.REFACTOR,
  REWORK: metricNames.REWORK,
  PR_MERGED_WITHOUT_REVIEW: metricNames.PR_MERGED_WITHOUT_REVIEW,
  COMMIT_CODE_CHANGES: metricNames.COMMIT_CODE_CHANGES,
  COMMIT_COUNT: metricNames.COMMIT_COUNT,
  PR_NEW: metricNames.PR_NEW,
  REVIEWS: metricNames.REVIEWS,
  ACTIVE_DAYS: metricNames.ACTIVE_DAYS,
  DONE_BRANCHES: metricNames.DONE_BRANCHES,
  ACTIVE_BRANCHES: metricNames.ACTIVE_BRANCHES
};
